import { AllParty, PageMeta, StateParty } from '../';
import { Gpt } from 'react-gpt-ads';
import './Seats.css';

const Seats = () => (
  <div className="home-page">
    <PageMeta prefix="议席总览" />
    <div className="seats-section">
      <h2 className="seats-section__title">议席列表</h2>
      <AllParty />
    </div>

    <div className="home-ad-slot">
      <Gpt
        adUnit="/2163006/election2023_top"
        name="div-gpt-ad-1666944904129-0"
        size={[[300, 250], [336, 280], 'fluid']}
      />
    </div>

    <div className="seats-section">
      <h2 className="seats-section__title">州议席</h2>
      <StateParty />
    </div>
  </div>
);

export default Seats;
